import { getModalityLabel } from '../../vacations.definitions';
import type { VacationRequest, VacationSegment, SegmentDecision } from '../../models/vacation.types';
import { resolveManagerEmail } from '../../utils/vacationRequestStatus';
import { resolveCorrectionReturnNote } from '../../utils/vacationSegments';
import { formatDateSafe } from '@/utils/dateUtils';
import { SummaryApproval, SummaryFacts, SummaryPeriods } from './components';

interface VacationRequestSummaryProps {
    request: VacationRequest;
    concessiveDeadline: string | null;
    deadlineIsProjected?: boolean;
    managerName?: string | null;
    showDeadline?: boolean;
    renderPeriodAction?: (segment: VacationSegment, decision: SegmentDecision | undefined) => React.ReactNode;
    actionPlacement?: 'divider' | 'plain';
}

export function VacationRequestSummary({
    request,
    concessiveDeadline,
    deadlineIsProjected = false,
    managerName,
    showDeadline = false,
    renderPeriodAction,
    actionPlacement = 'divider',
}: VacationRequestSummaryProps) {
    const deadline = request.concessiveDeadline ?? concessiveDeadline;
    const showProjectedHint = deadlineIsProjected && !request.concessiveDeadline;
    const managerEmail = resolveManagerEmail(request);
    const requestedAt = request.requestedAt?.toDate ? request.requestedAt.toDate() : null;

    return (
        <div className="space-y-4">
            <SummaryPeriods
                segments={request.segments}
                dpSegmentDecisions={request.dpSegmentDecisions}
                clientSegmentDecisions={request.clientSegmentDecisions}
                requestStatus={request.status}
                correctionReturnNote={resolveCorrectionReturnNote(request)}
                renderAction={renderPeriodAction}
                actionPlacement={actionPlacement}
            />

            <SummaryFacts
                modalityLabel={getModalityLabel(request.modality)}
                sellRequest={request.sellRequest}
                deadline={showDeadline && deadline ? formatDateSafe(deadline) : null}
                deadlineRaw={showDeadline && deadline ? deadline : null}
                showProjectedHint={showProjectedHint}
            />

            <SummaryApproval
                managerEmail={managerEmail}
                managerName={managerName}
                requestedAt={requestedAt ? formatDateSafe(requestedAt) : null}
            />
        </div>
    );
}

export default VacationRequestSummary;
